module.exports = __webpack_public_path__ + "static/media/profile_picture.f88b0406.jpg";